
export class Fornitore {
    id!: number;
    nome!: string;
    indirizzo!: string;
    pIva!: string;
    codiceUnivoco!: string;
    email!: string;
    numeroTelefono!: string;
    //aziendeAssociate!: AziendaObject[];

    static fromJson(json: any): Fornitore {
        let result = new Fornitore();
        result.id = json.id;
        result.nome = json.nome;
        result.indirizzo = json.indirizzo;
        result.pIva = json.pIva;
        result.codiceUnivoco = json.codiceUnivoco;
        result.email = json.email;
        result.numeroTelefono = json.numeroTelefono;
        //result.aziendeAssociate = json.aziendeAssociate.map((azienda: any) => AziendaObject.fromJson(azienda));
        return result;
    }
}
